import _getDaysInMonth from 'date-fns/getDaysInMonth';

function _parseNumber(value: number | string | null | undefined, defaultValue: number): number {
  if (value == null) return defaultValue;

  const num = Number(value);
  return Number.isNaN(num) ? defaultValue : num;
}

export default function getDaysInMonth(
  month: number | string | null | undefined,
  year?: number | string | null | undefined
): number {
  const monthNum = Math.min(Math.max(_parseNumber(month, 1), 1), 12);
  // Default to a leap year value so that 29 is returned for February, to be safe.
  const yearNum = _parseNumber(year, 2020);
  return _getDaysInMonth(new Date(yearNum, monthNum - 1, 1));
}
